import '../Sass/App.scss';
import React, { useContext } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { CartContext } from '../Contexts/CartContext';

function componentList(components) {
    return String(components || '')
        .split(',')
        .map((component) => component.trim())
        .filter(Boolean);
}

function formatPrice(price) {
    return `$${Number(price || 0).toFixed(2)}`;
}

export function BootkitItem(props) {

    const cart = useContext(CartContext);
    const inCart = cart.isInCart(props.bootkit.kit_id, 'bootkit');
    const components = componentList(props.bootkit.components);

    return (
        <div className='shop-box bootkit-box'>
            <div className='shop-box-content'>
                <Grid container spacing={2}>
                    <Grid xs={12} md={8}>
                        <h1>{props.bootkit.name}</h1>
                        <div className='green-code'>{props.bootkit.description}</div>
                        {props.bootkit.flavor && <div className='documentation-text bootkit-flavor'>{props.bootkit.flavor}</div>}
                    </Grid>
                    <Grid style={{ textAlign: 'right' }} xs={12} md={4}>
                        <span className="component-tag component-tag-price">{formatPrice(props.bootkit.price)}</span>
                        <span className="component-tag">{props.bootkit.codebase_credits || 0} codebase credits</span>
                    </Grid>
                    {components.length > 0 && (
                        <Grid xs={12}>
                            <div className="bootkit-components">
                                {components.map((component) =>
                                    <span className="component-tag" key={component}>{component}</span>
                                )}
                            </div>
                        </Grid>
                    )}
                    <Grid xs={12}>
                        <button className={inCart ? "cli-button-white" : "cli-button"} onClick={() => cart.addBootkit(props.bootkit)}>
                            {inCart ? 'in cart' : 'add to cart'}
                        </button>
                    </Grid>
                </Grid>
            </div>
        </div>
    )
}
